import { render, staticRenderFns } from "./modalAddTermsToAttribute.vue?vue&type=template&id=c584a44a&"
import script from "./modalAddTermsToAttribute.vue?vue&type=script&lang=js&"
export * from "./modalAddTermsToAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports